export default __webpack_public_path__ + "static/media/GameHive.d0ebb13e.png";